import {HAVA_DURUMU_URL} from "./constants";

export interface WeatherCurrent {
  temperature: number;
  feelsLike: number;
  humidity: number;
  windSpeed: number;
  weatherCode: number;
}

export interface WeatherDaily {
  date: string;
  max: number;
  min: number;
  weatherCode: number;
}

export interface WeatherData {
  current: WeatherCurrent;
  daily: WeatherDaily[];
}

// NOT: Projede sorgulamaService.ts içinde muhtemelen ortak bir axios instance'ı
// (auth header, base URL vb. ile) zaten var. Onu kullanmak istersen bu dosyayı
// o instance'ı import edecek şekilde güncelle; endpoint kimlik doğrulama
// gerektirmediği için burada basit fetch ile bırakıldı.
const weatherService = {
  getHavaDurumu: async (): Promise<WeatherData> => {
    const response = await fetch(HAVA_DURUMU_URL);
    if (!response.ok) {
      throw new Error('Hava durumu alınamadı');
    }
    return response.json();
  },
};

export default weatherService;
